import React from "react";
import { Link } from "@hdir/ui/link";
import { Chip } from "@hdir/ui/chip";
import { CardBanner } from "@hdir/ui/card";
import { faTriangleExclamation } from "@fortawesome/pro-light-svg-icons";
import FontAwesomeIconWrapper from "../../FontAwesomeIconWrapper/FontAwesomeIconWrapper";
import CardTitleHeader from "../../CardTitleHeader/CardTitleHeader";

import type { TilskuddProps } from "../../../../lib/modules/listSearchUtils/index.d";

export default function Tilskudd(props: Readonly<TilskuddProps>) {
  const {
    title,
    korttittel,
    link,
    deadlineDay,
    deadlineMonth,
    deadlineYear,
    themeTilskudd,
    eligibleAppliersTilskudd,
    deadlineExpired,
    deadlineRawFormat,
    localizedForListSearch,
    groupBy
  } = props;

  const hasEnoughContent = !!(korttittel || title || link);
  if (!hasEnoughContent) return null;

  return (
    <Link href={link} variant="card" className={`min-w-full h-full ${deadlineExpired ? "!border-feedback-error" : ""} p-0`}>
      { deadlineExpired
        ? (
          <div className="w-full">
            <CardBanner position="top">
              <div className="w-full bg-surface-feedback-error text-feedback-error pl-lg tablet:pl-[144px] py-sm">
                <p className="flex items-baseline gap-xs font-bold text-lg">
                  <FontAwesomeIconWrapper icon={faTriangleExclamation} />
                  {localizedForListSearch?.expired ?? "Utløpt"}
                </p>
              </div>
            </CardBanner>
          </div>
        )
        : null }

      <div className="flex nt-flex-col tablet:nt-flex-row p-xs tablet:p-lg desktop:gap-md">
        <time dateTime={deadlineRawFormat} className="flex nt-flex-row tablet:nt-flex-col justify-start tablet:justify-center content-center items-center tablet:items-center min-w-24 text-action text-center font-semibold pr-md">
          <span className="nt-text-md tablet:text-[36px] tablet:font-bold leading-8 mr-xxs">
            {deadlineDay}
            <span className="tablet:hidden">.</span>
          </span>
          <span className="mr-xxs text-md first-letter:lowercase tablet:first-letter:uppercase tablet:font-normal">{deadlineMonth}</span>
          <span className="text-md">{deadlineYear}</span>
        </time>
        <div className="flex flex-col flex-wrap gap-md min-w-64 break-words whitespace-normal">
          <CardTitleHeader title={title} korttittel={korttittel} groupBy={groupBy} />
          { themeTilskudd && themeTilskudd?.length > 0 && (
            <div className="flex flex-wrap gap-sm tablet:gap-md">
              {themeTilskudd?.map((theme) => (
                <Chip key={theme} className="p-xs bg-surface-feedback-success text-icon-feedback-success border-feedback-success leading-4" size="large">
                  {theme}
                </Chip>
              ))}
            </div>
          )}

          { eligibleAppliersTilskudd && eligibleAppliersTilskudd?.length > 0 && (
            <p>
              {localizedForListSearch?.eligableAppliers ?? "Kan søkes av"}
              :
              {" "}
              <span className="font-bold">{eligibleAppliersTilskudd?.join(", ")}</span>
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}
